"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthereumPort = void 0;
const seaport_js_1 = require("@opensea/seaport-js");
const ethers_1 = require("ethers");
const config_1 = __importDefault(require("../../../vendor/config"));
const types_1 = require("./types");
const Logger = 'CandyShopSDK/EthereumPort';
/**
 * Handling the Ethereum transactions by Seaport
 */
class EthereumPort {
    constructor() {
        this.percentageBase = 100;
        this.apiPath = 'eth';
        this.logger = 'EthereumPort';
    }
    /**
     * Seller uses this function to cancel a listing.
     * @param signer
     * @param uuid orderUuid
     * @returns
     */
    async cancelOrder(signer, uuid) {
        const seaport = new seaport_js_1.Seaport(signer);
        const accountAddress = await signer.getAddress();
        const order = await this.getOrderByUuid(uuid);
        const orders = [JSON.parse(order.rawOrderParams)];
        const tx = await seaport.cancelOrders(orders, accountAddress).transact();
        const receipt = await tx.wait();
        return receipt.transactionHash;
    }
    /**
     * Buyer uses this to fulfill an order.
     * @param signer
     * @param uuid
     * @returns
     */
    async fulfillOrder(signer, uuid) {
        const seaport = new seaport_js_1.Seaport(signer);
        const order = await this.getOrderByUuid(uuid);
        const accountAddress = await signer.getAddress();
        const orderComponents = JSON.parse(order.rawOrderParams);
        const { executeAllActions } = await seaport.fulfillOrder({
            order: { parameters: orderComponents, signature: order.signature },
            accountAddress
        });
        const execution = await executeAllActions();
        const receipt = await execution.wait();
        return receipt.transactionHash;
    }
    calculatePaymentSplitAmount(value, percentage) {
        const totalAmount = ethers_1.ethers.BigNumber.from(value);
        const splitAmount = totalAmount.mul(parseFloat(percentage) * this.percentageBase).div(this.percentageBase);
        return splitAmount;
    }
    getSplitReceiver(splitReceiver, offerer, shop) {
        switch (splitReceiver) {
            case types_1.SplitReceiver.ShopOwner:
                return shop.ownerAddress;
            case types_1.SplitReceiver.Seller:
                return offerer;
            case types_1.SplitReceiver.Platform:
                return '0x358061bdbEfCb392105375D932Cc13c32f81A334';
            default:
                throw Error('invalid split receiver value');
        }
    }
    getConsiderationFromOrder(offerer, consideration, shop) {
        const shopSplit = shop.paymentSplit;
        const considerations = [];
        for (const split of shopSplit) {
            const percentage = split.percentage;
            const splitReceiver = this.getSplitReceiver(split.receiver, offerer, shop);
            if (!(consideration === null || consideration === void 0 ? void 0 : consideration.value)) {
                console.log(`${Logger}: consideration.value is invalid of paymentSplit=`, split);
                continue;
            }
            const startAmount = this.calculatePaymentSplitAmount(consideration.value, percentage).toString();
            considerations.push({
                token: consideration.type === types_1.AssetType.ERC20 ? consideration.address : ethers_1.ethers.constants.AddressZero,
                amount: startAmount,
                recipient: splitReceiver
            });
        }
        return considerations;
    }
    convertToSeaportOrderData(orderComponents) {
        return {
            counter: orderComponents.counter,
            offerer: orderComponents.offerer,
            zone: orderComponents.zone,
            orderType: orderComponents.orderType,
            startTime: orderComponents.startTime.toString(),
            endTime: orderComponents.endTime.toString(),
            zoneHash: orderComponents.zoneHash,
            salt: orderComponents.salt,
            offer: orderComponents.offer,
            consideration: orderComponents.consideration,
            totalOriginalConsiderationItems: Number(orderComponents.totalOriginalConsiderationItems.toString()),
            conduitKey: orderComponents.conduitKey
        };
    }
    getShopByUuid(shopUuid) {
        return config_1.default.get(`${this.apiPath}/shop/${shopUuid}`).then((res) => res.data);
    }
    getOrderByUuid(orderUuid) {
        return config_1.default.get(`${this.apiPath}/order/${orderUuid}`).then((res) => res.data.result);
    }
    getFulfillOrderPayloadByUuidAndBuyerAddress(orderUuid, buyerAddress) {
        return config_1.default
            .get(`${this.apiPath}/order/payload/${orderUuid}/buyer/${buyerAddress}`)
            .then((res) => res.data.result);
    }
    /**
     * Execute orders by seaport and create orders in candy shop
     * @param params ExecuteOrderParams
     * @returns uuid of executed order
     */
    async executeOrder(params) {
        const seaport = new seaport_js_1.Seaport(params.signer);
        const shopUuid = params.shopUuid;
        const createOrderInput = params.createOrderInput;
        const { executeAllActions } = await seaport
            .createOrder(createOrderInput, params.accountAddress)
            .catch((err) => {
            console.log(`${this.logger}, failed to execute order, err=${err.message}`);
            throw err;
        });
        const orderRes = await executeAllActions().catch((err) => {
            console.log(`${this.logger}, failed to executeAllActions, err=${err.message}`);
            throw err;
        });
        const { signature, parameters } = orderRes;
        const data = {
            signature,
            orderData: this.convertToSeaportOrderData(parameters),
            shopUuid
        };
        const orderResult = await this.createOrder(data);
        return orderResult.uuid;
    }
    createOrder(createOrder) {
        return config_1.default.post(`${this.apiPath}/order`, createOrder).then((res) => res.data);
    }
}
exports.EthereumPort = EthereumPort;
